@if(params.colDef?.cellRendererParams?.formatAsAmount){<ds-textbox moneyDecimalNumber [textboxInput]="textboxConfig"
    (valueChange)="onChange($event)" (focused)="onFocus()" (blur)="onBlur()"></ds-textbox>}
@else if(params.colDef?.cellRendererParams?.twoDecimalOnly){<ds-textbox twoDigitDecimalNumber [textboxInput]="textboxConfig"
    (valueChange)="onChange($event)" (blur)="onBlur()"></ds-textbox>}
@else{
<ds-textbox twoDigitDecimalNumber [textboxInput]="textboxConfig" (valueChange)="onChange($event)" (blur)="onBlur()"></ds-textbox>

}
